/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Columns_HintInputs */



/**
* | output |
* | --- |
* | "Check to show. Drag to reorder." |
*
* @param {Editor_Table_Columns_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_columns_hint = /** @type {((inputs?: Editor_Table_Columns_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Columns_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cochez pour afficher. Glissez pour reordonner.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren Sie das Kontrollkästchen, um die Reihenfolge anzuzeigen. Ziehen Sie die Maus, um die Reihenfolge zu ändern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona per visualizzare. Trascina per riordinare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметьте галочкой, чтобы отобразить. Перетащите для изменения порядка.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marca para mostrar. Arrastra para reordenar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("勾选显示。拖动重新排序。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チェックを入れると表示されます。ドラッグすると並べ替えられます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दिखाने के लिए चेक करें। क्रम बदलने के लिए ड्रैग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marque para exibir. Arraste para reordenar.")
	return /** @type {LocalizedString} */ ("Check to show. Drag to reorder.")
});